// src/components/auth/SocialLoginDivider.tsx
// Divider component for separating traditional login from social login options

import React from 'react';
import { Box, Divider, Typography } from '@mui/material';

interface SocialLoginDividerProps {
  /** Text to display in the divider */
  text?: string;
}

/**
 * Visual divider between traditional login form and social login buttons
 */
const SocialLoginDivider: React.FC<SocialLoginDividerProps> = ({
  text = 'or continue with',
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', my: 3 }}>
      <Divider sx={{ flex: 1 }} />
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ px: 2, textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}
      >
        {text}
      </Typography>
      <Divider sx={{ flex: 1 }} />
    </Box>
  );
};

export default SocialLoginDivider;
